import { gql } from "apollo-boost";

const ROUTE_LOGIN = gql`
  mutation routeLogin($data: String, $email: String!, $origin: String!) {
    route_login(data: $data, email: $email, origin: $origin) {
      __typename
      ... on Error {
        message
      }
      ... on AccountCreated {
        message
        token
        analytics_data {
          user_id
          user_type
          flow
        }
      }
      ... on PasswordRequiredToRegister {
        message
        analytics_data {
          user_id
          user_type
          flow
        }
      }
      ... on SSOUser {
        url
        analytics_data {
          user_id
          user_type
          flow
        }
      }
      ... on PasswordRequested {
        message
        analytics_data {
          user_id
          user_type
          flow
        }
      }
      ... on VerificationSent {
        message
        analytics_data {
          user_id
          user_type
          flow
        }
      }
    }
  }
`;

export default ROUTE_LOGIN;
